/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserCreditsSlimStatusTierThresholds
 */
export interface UserCreditsSlimStatusTierThresholds {
    /**
     * 
     * @type {Array<number>}
     * @memberof UserCreditsSlimStatusTierThresholds
     */
    gondolaNightsCount?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof UserCreditsSlimStatusTierThresholds
     */
    gondolaSpend?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof UserCreditsSlimStatusTierThresholds
     */
    referralsCount?: Array<number>;
}

/**
 * Check if a given object implements the UserCreditsSlimStatusTierThresholds interface.
 */
export function instanceOfUserCreditsSlimStatusTierThresholds(value: object): value is UserCreditsSlimStatusTierThresholds {
    return true;
}

export function UserCreditsSlimStatusTierThresholdsFromJSON(json: any): UserCreditsSlimStatusTierThresholds {
    return UserCreditsSlimStatusTierThresholdsFromJSONTyped(json, false);
}

export function UserCreditsSlimStatusTierThresholdsFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserCreditsSlimStatusTierThresholds {
    if (json == null) {
        return json;
    }
    return {
        
        'gondolaNightsCount': json['gondola_nights_count'] == null ? undefined : json['gondola_nights_count'],
        'gondolaSpend': json['gondola_spend'] == null ? undefined : json['gondola_spend'],
        'referralsCount': json['referrals_count'] == null ? undefined : json['referrals_count'],
    };
}

export function UserCreditsSlimStatusTierThresholdsToJSON(json: any): UserCreditsSlimStatusTierThresholds {
    return UserCreditsSlimStatusTierThresholdsToJSONTyped(json, false);
}

export function UserCreditsSlimStatusTierThresholdsToJSONTyped(value?: UserCreditsSlimStatusTierThresholds | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'gondola_nights_count': value['gondolaNightsCount'],
        'gondola_spend': value['gondolaSpend'],
        'referrals_count': value['referralsCount'],
    };
}

